export const MAIN_SURFACE_Z_INDEX = 0;
export const MAX_OVERLAY_Z_INDEX = 2147483647;

export const STACK_SURFACE_Z_INDEX_BASE = 2000;
export const STACK_SURFACE_Z_INDEX_STEP = 10;

export const PLAYER_OVERLAY_SURFACE_Z_INDEX = 4000;
export const MODAL_SURFACE_Z_INDEX = 6000;
export const TRAY_SURFACE_Z_INDEX = 8000;
export const POPOVER_SURFACE_Z_INDEX = MAX_OVERLAY_Z_INDEX - 1;
export const TOAST_SURFACE_Z_INDEX = MAX_OVERLAY_Z_INDEX;

export const OVERLAY_LOCAL_UNDERLAY_Z_INDEX = 0;
export const OVERLAY_LOCAL_SURFACE_Z_INDEX = 1;

export function getOverlayContainerZIndex(surfaceZIndex: number) {
  return surfaceZIndex - 1;
}
